import classNames from 'classnames'

import { ReactComponent as Arrow } from 'images/arrow-up.svg'

import './button.style.css'

export type IconType = 'arrow'

export type Props = {
  title: string
  icon: IconType
  disabled?: boolean
  outline?: boolean
  round?: boolean
  onSubmit?: () => void
}

export const ImageComponent = (name: IconType) => {
  switch (name) {
    case 'arrow':
      return <Arrow className="rotate" />
    default:
      return <Arrow className="rotate" />
  }
}

export const IconButton = ({ title, icon, disabled, outline, round, onSubmit }: Props) => {
  const btnStyle: string = 'btn-primary'

  const classname = classNames('btn', btnStyle, {
    'btn-outline': outline,
    'btn-disabled': disabled,
    'btn-round': round,
  })

  return (
    <button
      disabled={disabled}
      className={classname}
      onClick={onSubmit}
      style={{ display: 'inline-flex' }}
    >
      <span style={{ width: 'max-content' }}>{title}</span>
      <span className="btn-icon">{ImageComponent(icon)}</span>
    </button>
  )
}
